import React, { useContext } from 'react'
import { reportFilterContext } from './report-filter-context'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'

export function FilterNotification({ className }: { className?: string }): JSX.Element | null {
  const { _t } = useTypedTranslation()
  const filterContext = useContext(reportFilterContext)
  const values = filterContext.getValues()

  if (!values || !Object.keys(values).length) {
    return null
  }

  return (
    <div className={'report-filter-notification ' + (className || '')}>
      <i className="ds3-icon ds3-filter"></i>
      <div>
        <strong className="me-1">{_t('filter-active')}</strong>
        <span className="me-1">{_t('filter-active-note')}</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault()
            filterContext.setValues({})
          }}
        >
          {_t('clear-filter')}
        </a>
      </div>
    </div>
  )
}
